import { render, staticRenderFns } from "./Off.vue?vue&type=template&id=48ebd3b8&scoped=true"
import script from "./Off.vue?vue&type=script&lang=js"
export * from "./Off.vue?vue&type=script&lang=js"
import style0 from "./Off.vue?vue&type=style&index=0&id=48ebd3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ebd3b8",
  null
  
)

export default component.exports